module Tapas.ViewModels {
    export class ProductViewModel extends Ftw.ViewModels.BaseViewModel {
        public ProductId = ko.observable('');
        public Quantity = ko.observable<number>(1);
        public Comment = ko.observable('');
        public Visible = ko.observable(true);
        public OrderTemplateViewModel = new OrderTemplateViewModel();
        public VariantId = ko.observable('');
        constructor(data) {
            super();
        }    
    }
}